<template>
  <div class="max-w-md px-4 mx-auto md:max-w-6xl justify-center md:px-4">
    <slot />
  </div>
</template>

<script setup></script>
